import React from "react";
import { createUseStyles } from "react-jss";
import VariantTemplate from "./Components/VariantTemplate";
import VariantTemplateBlock from "./Components/VariantTemplateBlock";

const useStyles = createUseStyles({
	boldText: {
		fontWeight: 700,
	},
	widthText: {
		maxWidth: "150px",
	},
});

function VariantAbonent(props) {
	const { boldText, widthText } = useStyles();
	const { text } = props;

	return (
		<VariantTemplate
			tariffVariant={text.VARIANT_ABONEMENT_1}
			linkProps={props.link}
			clickBackHandler={props.clickBackHandler}
			text={text}
		>
			<VariantTemplateBlock img={"/images/popup2/popup-icon12.jpg"}>
				{text.VARIANT_TEMPLATE_1}
				<span className={boldText}>{text.VARIANT_ABONEMENT_2}</span>
			</VariantTemplateBlock>
			<VariantTemplateBlock img={"/images/popup2/popup-icon13.jpg"}>
				{text.VARIANT_ABONEMENT_3}
			</VariantTemplateBlock>
			<VariantTemplateBlock img={"/images/popup2/popup-icon14.jpg"} descriptionItemProps={true}>
				<div className={widthText}>{text.VARIANT_ABONEMENT_4}</div>
			</VariantTemplateBlock>
		</VariantTemplate>
	);
}

export default VariantAbonent;
